export default () => ({
  show: false,
  isLoading: true,
  onCancel: false,
  fullPage: true,
  pet: {
    tower_id: null,
    unit_id: null,
    species: null,
    name: null,
    breed: null,
    color: null,
    status: true
  },
  pets: [],
  entity: 'pet',
  entities: 'pets',
  dwellerUnits: [],
  dwellerTowers: [],
  optionSpecies: [
    {
      id: '1',
      label: 'Cão'
    },
    {
      id: '2',
      label: 'Gato'
    },
    {
      id: '3',
      label: 'Ave'
    },
    {
      id: '4',
      label: 'Repteis'
    },
    {
      id: '5',
      label: 'Outros'
    }
  ],
  prefixRouter: 'dweller.pets'
})



// WEBPACK FOOTER //
// ./src/app/tenant/pets/resources/data.js